// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1TcN9","productName":"Table_productName__3tRTr"};